import React, { useState } from 'react';
import PropTypes from 'prop-types';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { DateRange } from 'react-date-range';
import { IconCalendarDays, IconClose } from '../icons';

const DateRangeSelect = ({ id, onChange, open, setOpen }) => {
  const [state, setState] = useState([
    {
      startDate: new Date(),
      endDate: null,
      key: 'selection',
      id: id,
    }
  ]);

  const handleOnChange = (ranges) => {
    const { selection } = ranges;
    onChange(selection);
    setState([selection]);
  }

  return (
    <>
      {open && (
        <DateRange
          editableDateInputs={true}
          onChange={handleOnChange}
          moveRangeOnFirstSelection={false}
          ranges={state}
        />
      )}
    </>
  )
}

DateRangeSelect.propTypes = {
  onChange: PropTypes.func,
  id: PropTypes.string,
};

const DateRangeButton = ({ open, setOpen }) => {
  return (
    <button type="button" className="cal-icon" onClick={() => setOpen(!open)}>
      {open ? <IconClose /> : <IconCalendarDays />}
      
    </button>
  )
}

DateRangeButton.propTypes = {
  onChange: PropTypes.func,
  id: PropTypes.string,
};


export { DateRangeSelect, DateRangeButton };
